import { Element } from '../../../common/html/element'
import { Responsive } from '../../../common/Responsive'
import style from '../index.module.scss'
import { Category } from './Category'
import { DateDownload } from './DateDownload'
import { ExpireDate } from './ExpireDate'
import { Search } from './Search'

export const HeaderDownloadedFiles = () => {
  const renderComponent = () => {
    return (
      <div style={{ paddingTop: 12 }}>
        <Element
          className={[style.groupAction, 'dFlex'].join(' ')}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Search />
          <Element
            className={style.itemSquare}
            style={{ backgroundColor: '#9c9c9c' }}
          />
          <Category />
          <Element
            className={style.itemSquare}
            style={{ backgroundColor: '#9c9c9c' }}
          />
          <DateDownload />
          <Element
            className={style.itemSquare}
            style={{ backgroundColor: '#9c9c9c' }}
          />
          <ExpireDate />
        </Element>
      </div>
    )
  }
  const renderComponentResponsive = () => {
    return (
      <div style={{ paddingTop: 12 }}>
        <Element
          className={style.groupActionResponsive}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <div className={style.searchInput}>
            <Search />
          </div>
          <div className={style.groupSearch}>
            <Category />
            <DateDownload />
            <ExpireDate />
          </div>
        </Element>
      </div>
    )
  }

  return (
    <Responsive renderResponsive={renderComponentResponsive}>
      {renderComponent()}
    </Responsive>
  )
}
